import { ICardValidity } from '@core/interfaces/card/card-validity.interface';
import { IGiftCardsToBuyCartItem } from '@core/interfaces/cart/giftcards-to-buy-cart-item.interface';
import { IGiftCardsToBuyDenomination } from '@core/interfaces/cart/giftcards-to-buy-denomination.interface';
import { AAGUID, parseArray } from '@interticket/core';
import { GiftCardsToBuyDenomination } from './giftcards-to-buy-denomination.model';

export class GiftCardsToBuyCartItem implements IGiftCardsToBuyCartItem {

  readonly name: string;
  readonly imageId: AAGUID;
  readonly templateId: AAGUID;
  readonly validity: ICardValidity;
  readonly denominations: GiftCardsToBuyDenomination[];

  constructor(iGiftCardsToBuyItem: IGiftCardsToBuyCartItem) {
    this.name = iGiftCardsToBuyItem.name;
    this.imageId = iGiftCardsToBuyItem.imageId;
    this.templateId = iGiftCardsToBuyItem.templateId;
    this.validity = iGiftCardsToBuyItem.validity;
    this.denominations = parseArray<IGiftCardsToBuyDenomination, GiftCardsToBuyDenomination>(iGiftCardsToBuyItem.denominations, GiftCardsToBuyDenomination);
  }

}
